import { query } from '@confluence/query-preloader-tools';
import { getOnboardingStateGQL } from '@confluence/onboarding-helpers/entry-points/getOnboardingStateGQL';
import { ENHANCE_ORIENTATION_TOUR_ONBOARDING_STATE_KEYS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';

export async function preloadEnhanceOrientationTour() {
	return query({
		query: getOnboardingStateGQL,
		variables: {
			key: Object.values(ENHANCE_ORIENTATION_TOUR_ONBOARDING_STATE_KEYS),
		},
	});
}
